import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: '../templates/loading.component.html',
  styleUrls: ['../templates/styles/loading.component.css']
})
export class LoadingComponent {
  isLoading: boolean = true;

  // Метод для установки состояния загрузки
  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}
